<template>
  <div v-if="userSignedIn == null" id="app">
    <main style="margin-top: 3rem; margin-bottom:3rem;">
      <Loading loadingString="LockerApp"/>
    </main>
  </div>

  <div v-else id="app">
    <NavBar :userSignedIn="userSignedIn" />
    <main style="margin-top: 3rem; margin-bottom:3rem;">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";
import Loading from './components/Loading.vue'
import firebase from "firebase/app";
import 'firebase/auth'

export default {
  name: "App",
  data: function () {
    return {
      userSignedIn: null,
    };
  },
  components: {
    NavBar,
    Footer,
    Loading
  },
  watch: {
    // Setting up page title
    $route: {
      immediate: true,
        handler(to) {
          document.title = to.meta.title || 'LockerApp';
        }
      },
  },
  mounted: function () {
    this.userSignedIn = null;

    var config = {
      apiKey: "AIzaSyD68HQoibPvfs8_rsb23sRhNHCBBd0IWqE",
      authDomain: "lockerapp-78f84.firebaseapp.com",
      databaseURL: "https://lockerapp-78f84.firebaseio.com",
      projectId: "lockerapp-78f84",
      storageBucket: "lockerapp-78f84.appspot.com",
      messagingSenderId: "728981587651",
      appId: "1:728981587651:web:621cefd6265cfa12f80476",
      measurementId: "G-X6YDX0S7F7"
    };
    firebase.initializeApp(config);

    let vueInstance = this;

    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        if (!firebase.auth().currentUser.emailVerified) {
          /* log the user out */
          firebase.auth().signOut();
          vueInstance.userSignedIn = false;
        } else {
          vueInstance.userSignedIn = true;
          //vueInstance.$router.push({ name: "Passwords" });
        }
      } else {
        vueInstance.userSignedIn = false;
      }
    });
  },
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s | LockerApp',
    // Define meta tags here.
    meta: [
      {name: 'description', content: 'LockerApp is a password manager that lets you protect the passwords of your social media accounts, email accounts, and much more, you can keep your notes secret as well. | LockerApp | Password Manager | Encrypted Passwords | Encrypted Notes | Generate a new strong password'},
      {name: 'application-name', content: 'LockerApp'},
      {name: 'author', content: 'Emre Biçer'},
      {name: 'keywords', content: 'LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application'}    ]
  }
};
</script>

<style>

main {
  flex: 1 0 auto;
}
#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
}

@media (prefers-color-scheme: dark) {
    :root {
      --primary-bg-color: rgb(8,8,8)  ;
      --secondary-bg-color: rgb(20,20,20);
      --primary-fg-color: #fff;
      --secondary-fg-color: #42a5f5 ;
      --red-error-color: #d50000;
    }
    
    body {
      background-color: #000  ;
    }

 }

 @media (prefers-color-scheme: light) {
    :root {
      --primary-bg-color: #3f51b5;
      --secondary-bg-color: #212121;
      --primary-fg-color: #e0e0e0;
      --secondary-fg-color: #ffd54f;
      --red-error-color: #d50000;
    }

    body {
      background-color: #e8eaf6;
    }

 }

.error-fg{
  color: var(--red-error-color) !important;
}

.error-bg{
  background-color: var(--red-error-color) !important;
}

.primary-bg {
  background-color: var(--primary-bg-color) !important;
}

.secondary-bg {
  background-color: var(--secondary-bg-color) !important;
}

.primary-fg {
  color: var(--primary-fg-color) !important;
}
.secondary-fg {
  color: var(--secondary-fg-color) !important;
}


.textareaBorder{
  border-color: var(--primary-fg-color) !important;
  box-shadow: 0 0px 0 0 var(--primary-fg-color) !important;
}

input {
  border-color: var(--primary-fg-color) !important;
  box-shadow: 0 1px 0 0 var(--primary-fg-color) !important;
}

input.invalid {
  border-color: red !important;
  box-shadow: 0 1px 0 0 red !important;
}

input.valid {
  border-color: #4caf50 !important;
  box-shadow: 0 1px 0 0 #4caf50 !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px rgba(33, 33, 33, 0.9) inset !important;
  box-shadow: 0 0 0 30px rgba(33, 33, 33, 0.9) inset !important;
}

/*Change text in autofill textbox*/
input:-webkit-autofill {
  -webkit-text-fill-color: white !important;
}

label {
  color: var(--primary-fg-color) !important;
}

.roundedBorder {
  border: 0px solid;
  border-radius: 1rem;
}
</style>
